import { render, staticRenderFns } from "./selectSeat.vue?vue&type=template&id=22f2a0de&scoped=true&"
import script from "./selectSeat.vue?vue&type=script&lang=js&"
export * from "./selectSeat.vue?vue&type=script&lang=js&"
import style0 from "./selectSeat.vue?vue&type=style&index=0&id=22f2a0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2a0de",
  null
  
)

export default component.exports